<div class="app-loading-wrapper">
  <nz-spin nzSimple></nz-spin>
</div> 